/**
 * @file   SinglePriceSlider.js
 * @brief  Single-handle price explorer slider for Match tab.
 *         Centered on the property's asking price. Exploration only - does NOT
 *         re-fetch the match API. Updates the histogram highlighting and insight text.
 */
import React from "react";
import { formatCompactPrice } from "../../../helpers/priceCapUtils";
import "./SinglePriceSlider/single_price_slider.scss";

const SinglePriceSlider = ({
  value,
  onChange,
  min,
  max,
  step,
  askingPrice,
}) => {
  if (!max || max <= 0) return null;

  // Position of the asking price marker on the track (percentage)
  const askingPct = askingPrice > 0
    ? Math.min(Math.max(((askingPrice - min) / (max - min)) * 100, 0), 100)
    : null;

  // Position of the current slider thumb
  const thumbPct = value != null
    ? Math.min(Math.max(((value - min) / (max - min)) * 100, 0), 100)
    : null;

  return (
    <div className="single-price-slider">
      {/* Current price label above thumb */}
      {thumbPct != null && (
        <div
          className="single-price-slider__label"
          style={{ left: `${thumbPct}%` }}
        >
          {formatCompactPrice(value)}
        </div>
      )}

      <div className="single-price-slider__track-wrap">
        {/* Asking price marker on track */}
        {askingPct != null && (
          <div
            className="single-price-slider__asking-marker"
            style={{ left: `${askingPct}%` }}
            title="Your asking price"
          />
        )}

        <input
          type="range"
          className="single-price-slider__input"
          min={min}
          max={max}
          step={step || 1}
          value={value ?? askingPrice ?? min}
          onChange={(e) => onChange(Number(e.target.value))}
        />
      </div>

      {/* Min/max labels */}
      <div className="single-price-slider__range-labels">
        <span>{formatCompactPrice(min)}</span>
        <span>{formatCompactPrice(max)}</span>
      </div>
    </div>
  );
};

export default SinglePriceSlider;
